import { Link } from "react-router-dom";
import { Facebook, Instagram } from "lucide-react";

const legalLinks = [
  { label: "Impressum", href: "/impressum" },
  { label: "Datenschutzerklärung", href: "/datenschutz" },
  { label: "Barrierefreiheitserklärung", href: "/barrierefreiheit" },
];

const ReweFooter = () => (
  <footer className="px-6 md:px-16 py-16 border-t border-border" role="contentinfo">
    <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center md:items-start gap-12">
      <div className="text-center md:text-left">
        <p className="font-display text-2xl font-bold">
          <span className="text-primary-bright">REWE</span>
          <span className="text-muted-foreground text-sm font-body ml-2">Kotlarski</span>
        </p>
        <p
          className="mt-4 text-muted-foreground font-body text-sm max-w-xs leading-relaxed"
          style={{ textWrap: "pretty" as any }}
        >
          Ein kleiner Markt mit familiärer Atmosphäre in Meerbusch-Osterath. Bei uns ist jeder Kunde willkommen.
        </p>

        {/* Social Icons mobile: stacked, desktop: inline */}
        <ul className="mt-6 flex justify-center md:justify-start gap-4 list-none m-0 p-0">
          <li>
          <a
            href="https://www.facebook.com/profile.php?id=61561263476067"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook Profil besuchen"
            className="text-muted-foreground hover:text-foreground transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background rounded p-1"
          >
            <Facebook size={20} aria-hidden="true" />
          </a>
          </li>
          <li>
          <a
            href="https://www.instagram.com/rewe.kotlarski/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram Profil besuchen"
            className="text-muted-foreground hover:text-foreground transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background rounded p-1"
          >
            <Instagram size={20} aria-hidden="true" />
          </a>
          </li>
        </ul>
      </div>

      <div>
        <h2 className="font-display text-sm font-semibold text-foreground mb-4 tracking-wide text-center md:text-left">
          Rechtliches
        </h2>
        <nav aria-label="Rechtliche Seiten">
          <ul className="flex flex-col items-center md:items-start gap-2 list-none m-0 p-0">
          {legalLinks.map((l) => (
            <li key={l.label}>
            <Link
              to={l.href}
              className="text-sm text-muted-foreground hover:text-foreground transition-colors font-body focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background rounded px-1"
              style={{ textWrap: "pretty" as any }}
            >
              {l.label}
            </Link>
            </li>
          ))}
          </ul>
        </nav>
      </div>
    </div>

    <div className="max-w-7xl mx-auto mt-16 pt-8 border-t border-border text-center">
      <p className="text-xs text-muted-foreground font-body" style={{ textWrap: "pretty" as any }}>
        <span className="inline-block">Copyright by Rewe Peter Kotlarski OHG</span>
        <span className="inline-block mx-2">|</span>
        <span className="inline-block">
          Powered by{" "}
          <a
            href="https://flh-mediadigital.de"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-foreground transition-colors"
          >
            FLH MEDIA DIGITAL
          </a>
        </span>
      </p>
    </div>
  </footer>
);

export default ReweFooter;